<div class="modal-header">
  <h4 class="modal-title synchpc-primary" id="modal-title">{{ toAdd ? "Add" : "Update" }} Storage - {{ cloudName }}</h4>
  <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
</div>
<div class="modal-body text-grey">
  <form action="" [formGroup]="formGroup">
    <div *ngIf="toAdd">
      <div class="form-group">
        <label for="state">Storage Type</label>
        <ng-select [items]="storageTypes"
                   bindLabel="key"
                   bindValue="value"
                   [multiple]="false"
                   [clearable]="false"
                   placeholder="Select type"
                   formControlName="type">
        </ng-select>
      </div>
  
      <hr>
  
      <div class="d-flex flex-wrap gap-3">
        <mat-form-field>
          <mat-label>Storage Name</mat-label>
          <input type="text" matInput formControlName="name" placeholder="Name for storage">
          <mat-error *ngIf="formGroup.get('name').hasError('pattern')">
            Name should not contain special characters. Regex supported (^[a-z0-9]+$).
          </mat-error>
          <mat-error *ngIf="formGroup.get('name').hasError('required')">
            Name is required
          </mat-error>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Deployment Name</mat-label>
          <mat-select formControlName="deployment">
            <mat-option *ngFor="let dep of deploymentNames" [value]="dep">{{ dep }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Location</mat-label>
          <mat-select formControlName="location">
            <mat-option *ngFor="let loc of getLocations()" [value]="loc">{{ loc }}</mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field>
          <mat-label>Credentials</mat-label>
          <mat-select formControlName="credential">
            <mat-option *ngFor="let cred of credentials" [value]="cred.friendlyName">{{ cred.friendlyName }}</mat-option>
          </mat-select>
        </mat-form-field>
  
        <div *ngIf="formGroup.get('type').value == 'bucket'" class="d-flex flex-wrap gap-3">
          <mat-form-field>
            <mat-label>Storage Class</mat-label>
            <mat-select formControlName="storageClass">
              <mat-option *ngFor="let class of getStorageClass()" [value]="class">{{ class }}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div *ngIf="formGroup.value.type == 'fileStore'" class="d-flex flex-wrap gap-3">
          <mat-form-field>
            <mat-label>FileShare Name</mat-label>
            <input matInput formControlName="fileShareName" placeholder="syncstore">
          </mat-form-field>
          <mat-form-field floatLabel="always">
            <mat-label>Mount Directory</mat-label>
            <input matInput formControlName="mountDirectory" title="Enter the mount directory after '/mnt/'">
            <mat-error *ngIf="formGroup.get('mountDirectory').hasError('pattern')">
              Enter mount directory starting with /mnt/--path--
            </mat-error>
          </mat-form-field>
          <mat-form-field>
            <mat-label>Size ( in TB )</mat-label>
            <input matInput formControlName="size" placeholder="Size in TB">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Network</mat-label>
            <input matInput formControlName="network" placeholder="Default" value="Sushi">
          </mat-form-field>
          <mat-form-field>
            <mat-label>Service Tier</mat-label>
            <mat-select formControlName="serviceTier">
              <mat-option *ngFor="let tier of getServiceTier()" [value]="tier">{{ tier }}</mat-option>
            </mat-select>
          </mat-form-field>
          <br>
        </div>
      </div>  
    </div>
    
    <div *ngIf="!toAdd">
      <mat-form-field class="w-100">
        <mat-label>Size</mat-label>
        <input matInput formControlName="size" placeholder="Size in TB">
      </mat-form-field>
    </div>

    <br>
    <mat-form-field class="w-100">
      <mat-label>Description</mat-label>
      <textarea matInput placeholder="" formControlName="description"></textarea>
    </mat-form-field>

  </form>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" mat-dialog-close>Cancel</button>
  <button type="button" class="btn btn-primary" (click)="onSubmit()">
    Create
  </button>
</div>